<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.detailsInfo }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />

                      <form-error :model="$v.title" label="Naziv" :dirty="$v.$dirty" />
                     </div>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'Tags' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  components: { FormError },
  name: 'AddTag',
  mixins: [translations],
  validations,
  data() {
    return {
      title: '',
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const { title } = this;

      api.createTag({ title })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Tags' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
  },
};
</script>